import { render } from "./RentalPayment.vue?vue&type=template&id=6770ee6a"
import script from "./RentalPayment.vue?vue&type=script&lang=js"
export * from "./RentalPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__